import React from 'react';
import { Dialog } from 'primereact/dialog';

interface CourseNotesDialogProps {
  visible: boolean;
  onHide: () => void;
  courseName: string;
  notes: string;
}

export const CourseNotesDialog: React.FC<CourseNotesDialogProps> = ({
  visible,
  onHide,
  courseName,
  notes,
}) => {
  return (
    <Dialog
      header={`הערות - ${courseName}`}
      visible={visible}
      onHide={onHide}
      style={{ width: '500px' }}
      modal
      draggable={false}
    >
      <div
        style={{
          padding: '12px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #e0e0e0',
          minHeight: '100px',
        }}
      >
        <div
          style={{
            color: '#404040',
            fontSize: '14px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {notes || 'אין הערות'}
        </div>
      </div>
    </Dialog>
  );
};
